export default "__VITE_ASSET__DYIRRMTx__"